import EmblaCarousel from "embla-carousel";
import { initEmblaProgress } from "@theme/critical";

function initHeroSlider(root) {
  const viewport = root.querySelector(".embla__viewport");
  if (!viewport || root.dataset.emblaReady === "true") return;

  const slides = root.querySelectorAll(".embla__slide");
  if (slides.length < 2) return;

  const embla = EmblaCarousel(viewport, {
    loop: true,
    align: "start",
    containScroll: "trimSnaps",
    duration: 22,
    watchDrag: true,
  });
  root.dataset.emblaReady = "true";
  initEmblaProgress(root, embla);

  const prev = root.querySelector("[data-hero-prev]");
  const next = root.querySelector("[data-hero-next]");
  if (prev) prev.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    embla.scrollPrev();
  });
  if (next) next.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    embla.scrollNext();
  });

  let dragged = false;
  embla.on("pointerDown", () => {
    dragged = false;
  });
  embla.on("scroll", () => {
    dragged = true;
  });
  root.querySelectorAll("a.hero-slide-link").forEach((link) => {
    link.setAttribute("draggable", "false");
    link.addEventListener("click", (event) => {
      if (dragged) event.preventDefault();
    });
  });

  const delay = Number(root.dataset.autoplay || 0);
  if (delay > 0) {
    let timer = 0;
    const stop = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = 0;
      }
    };
    const play = () => {
      stop();
      timer = window.setInterval(() => embla.scrollNext(), delay);
    };

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", play);
    root.addEventListener("focusin", stop);
    root.addEventListener("focusout", play);
    embla.on("pointerDown", stop);
    embla.on("pointerUp", play);
    embla.on("settle", play);
    play();
  }

  let resizeTimer = 0;
  window.addEventListener(
    "resize",
    () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => embla.reInit(), 150);
    },
    { passive: true }
  );
}

function initAll(scope = document) {
  scope.querySelectorAll("[data-hero-slider]").forEach(initHeroSlider);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initAll(), { once: true });
} else {
  initAll();
}

document.addEventListener("shopify:section:load", (event) => {
  if (event.target instanceof HTMLElement) {
    initAll(event.target);
  }
});
